<div class="modal-header ">
    <!-- p-0 py-2 px-3 -->
    <!-- <h4 class="modal-title text-center" id="myCenterModalLabel">Forget Password</h4> -->
       
    <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
</div>
<div class="modal-body" [formGroup]="UpdatePasswordForm">   
<div *ngIf="showErrorDiv" class="alert alert-danger error-message d-flex align-items-center p-2 mb-3" role="alert">
                            <div>
                                <span class="text-danger-emphasis">
                                    <i class="fs-3 ti ti-bomb"></i> {{ currentMessage }}
                                </span>
                            </div>
                           
                        </div>
    <app-input-static-fields 
    code="fa fa-eye-slash"
    label="Previous Password"
    [formGroup]="UpdatePasswordForm"
    formControlValue="previouspassword"
    type="password"
    maxlength="15"
    [name]="'previouspassword'"
 />
 <app-input-static-fields 
 code="fa fa-eye-slash"
 label="Choose a Password"
 [formGroup]="UpdatePasswordForm"
 formControlValue="currentpassword"
 type="password"
 maxlength="15"
 [name]="'currentpassword'"
>
 <div class="password-strength" *ngIf="passwordStrength">
                <div class="block-container">
                <div class="strength-block" [ngClass]="{
                    'active': passwordStrengthPercentage >= 33,
                    'weak': passwordStrength === 'Weak',
                    'medium': passwordStrength === 'Medium',
                    'strong': passwordStrength === 'Strong'
                }"></div>
                <div class="strength-block" [ngClass]="{
                    'active': passwordStrengthPercentage >= 66,
                    'medium': passwordStrength === 'Medium' || passwordStrength === 'Strong'
                }"></div>
                <div class="strength-block" [ngClass]="{
                    'active': passwordStrengthPercentage >= 100,
                    'strong': passwordStrength === 'Strong'
                }"></div>
                </div>
                <span class="strength-text">{{ translate(passwordStrength) }}</span>
            </div>
</app-input-static-fields>
<!-- ✅ Password Hint Displayed below the Password Field -->
  <div class="text-muted fs-13 passwordHint" >
     {{ translate('PASSWORDHINT') }}
     </div>
<app-input-static-fields 
code="fa fa-eye"
label="Repeat Password"
[formGroup]="UpdatePasswordForm"
formControlValue="repeatpassword"
type="password"maxlength="15"[name]="'repeatpassword'"/>


 <!-- ✅ Password Hint Displayed below the Password Field -->
  <div class="text-muted fs-13 passwordHint" >
     {{ translate('PASSWORDHINT') }}
     </div>
    <div class=" py-3">
        <button 
          class="btn btn-lg w-100 btnForgetPassword"
          type="submit"
          (click)="onSubmit()"
          [disabled]="UpdatePasswordForm.invalid">Update</button>
         
    </div>
  
</div>